import React, {
    useState,
    useEffect,
    useContext
} from 'react';
import { GameItem } from '../GameItem/GameItem';
import { NoResult } from '../NoResult/NoResult';
import {
    AsgAppContext,
    AsgAppGamesContext,
    AsgDictionaryContext
} from '../../contexts';
import clearImg from '../../../images/clear.svg';
import loaderImg from '../../../images/loader.svg';
import { GameImprovementsTitle } from '../GameImprovementsTitle/GameImprovmentsTitle';
import './SearchGames.css';

/**
 * Parent component for all live casino pane rendered on top of game grid item
 * @param gameInfo
 * @return {JSX.Element}
 * @constructor
 */
export const SearchGames = ({
    gamesListItem,
    recentGames,
    searchOpenStatus,
    changeStatus,
    changeMobilePanelOpenStatus
}) => {
    const AsgApp = useContext(AsgAppContext);
    const Games = useContext(AsgAppGamesContext);

    /**
     * state parameters
     */
    const [textSearch, setTextSearch] = useState('');
    const [gamesList, setGamesList] = useState({});
    const [gamesResult, setGamesResult] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    /**
     * used dictionary
     * @type {{}}
     */
    const dictionary = useContext(AsgDictionaryContext);
    const placeholder = dictionary.translate('searchGames');
    const noGamesFound = dictionary.translate('noResults');



    useEffect(() => {
        setGamesList(gamesListItem);
    }, []);

    const clearResult = () => {
        setTextSearch('');
        setGamesResult([]);
    };

    const handleSearchOpenStatus = (data) => {
        if (data) {
            const GAEventName = 'Search - ' + (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop') + ' game page';
            AsgApp.GAeventTracking(GAEventName, textSearch, data.name);
        }
        setTextSearch('');
        setGamesResult([]);
        changeStatus(!searchOpenStatus);
    };

    const handleOpenSearchInput = () => {
        handleSearchOpenStatus(null);
    };

    const handleOnSearchGameChang = (e) => {
        let temp = AsgApp.stripHtml(e.target.value.toLowerCase());
        setTextSearch(temp);
        setGamesResult([]);
        getResult(temp);
    };

    const getResult = (inputFromUser) => {
        if (!inputFromUser.length) {
            setGamesResult([]);
            return;
        }
        setShowLoader(true);
        let result = [];
        let nameResult = Games.filterGamesByName(inputFromUser, gamesList);
        let providerResult = Games.filterGamesByProvider(inputFromUser, gamesList);
        let subProviderResult = Games.filterGamesBySubProvider(inputFromUser, gamesList);

        result.push(...nameResult, ...subProviderResult, ...providerResult);

        setGamesResult(filterDuplicated(result));
        setShowLoader(false);
    };

    const filterDuplicated = (result) => {
        return result.filter((value, index) => (
            index === result.findIndex(obj => obj.id === value.id)
        ));
    };

    return (
        <div className={`search-game-component__btn-wrapper ${searchOpenStatus ? 'active' : ''}`}>
            <div
                className="search-game-component__btn cta-common"
                onClick={handleOpenSearchInput}
            > </div>
            {searchOpenStatus &&
                <div className="search-game-result-wrap" >
                    <GameImprovementsTitle title='search' />
                    <div className="search-game-component__input">
                        {
                            gamesResult && textSearch.length > 0
                                &&
                            (
                                showLoader ? <img src={loaderImg} className="clear-search" alt="" /> :
                                    <img onClick={clearResult} src={clearImg} className="clear-search" alt="" />
                            )
                        }
                        <div className="search-icon" />
                        <input
                            autoFocus
                            value={textSearch}
                            onChange={handleOnSearchGameChang}
                            type="text"
                            placeholder= {placeholder}
                            className="search-game__input"/>
                    </div>
                    <div className="search-game-component__result">
                        {
                            !gamesResult.length && !textSearch.length
                            &&
                            recentGames.slice(0, 5).map((item) => (
                                <GameItem onOpenGame={ () => {
                                    handleSearchOpenStatus(item);
                                    if (AsgFW.isMobilePamPlatform()) {
                                        changeMobilePanelOpenStatus(false);
                                    }
                                }}
                                key={item.id}
                                data={item}
                                />
                            ))
                        }
                        {
                            !gamesResult.length && textSearch.length > 0
                                && <NoResult
                                    noGamesFound={noGamesFound}
                                />
                        }
                        {
                            gamesResult.map((data) => (
                                <GameItem onOpenGame={ () => {
                                    handleSearchOpenStatus(data);
                                    if (AsgFW.isMobilePamPlatform()) {
                                        changeMobilePanelOpenStatus(false);
                                    }
                                }}
                                key={data.id}
                                data={data}
                                />
                            ))
                        }
                    </div>
                </div>
            }
        </div>
    );
};
